import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { truncateText } from '../utils';

interface TruncatedTypographyProps extends TypographyProps {
  label: string;
  text: string;
  maxLength?: number;
}

const TruncatedTypography: React.FC<TruncatedTypographyProps> = ({ label, text, maxLength = 75, ...props }) => {
  const truncatedValue = truncateText(text, maxLength);

  return (
    <Typography {...props}>
      <strong>{label}</strong> {truncatedValue}
    </Typography>
  );
};

export default TruncatedTypography;
